import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonModel } from '../models/person/person.model';

@Component({
  selector: 'app-invite-person-select-dialog',
  templateUrl: './invite-person-select-dialog.component.html',
  styleUrls: ['./invite-person-select-dialog.component.scss'],
  standalone: false
})
export class InvitePersonSelectDialogComponent {
  showModal = false;

  @Input()
  selectedPersons: PersonModel[] = [];

  @Input()
  selectedOrganisationUnitIds: string[] = [];

  @Input()
  selectedTrainingGroupIds: string[] = [];

  @Output() 
  selectedPersonsChange = new EventEmitter<PersonModel[]>();

  constructor() {}

  onSubmitClick = () => {
    this.selectedPersonsChange.emit(this.selectedPersons);
    this.toggleShowModal();
  };

  toggleShowModal() {
    this.showModal = !this.showModal;
  }

  toggle = () => {
    this.toggleShowModal();
  };
}
